import en from './en';
import cn from './cn';
import de from './de';
import ar from './ar';
import es from './es';
import fr from './fr';
import id from './id';
import it from './it';
import jp from './jp';
import kr from './kr';
import pt from './pt';
import ru from './ru';
import th from './th';
import tr from './tr';

export default {
    en: en,
    cn: cn,
    de: de,
    ar: ar,
    es: es,
    fr: fr,
    id: id,
    it: it,
    jp: jp,
    kr: kr,
    pt: pt,
    ru: ru,
    th: th,
    tr: tr,
}
